import axios from "axios";
import { useQuery } from "react-query";
import { objectWithIdNotFoundMessage } from "../../../Messages/errorMessages";
import { bidPackUrls } from "../../../URL/ApplicationUrls";
import { BidPack } from "../BidPack";
import { namedQueryKeyWithId } from "../../../ReactQuery/namedQueryKeyWithId";

export const useFetchBidPackById = (bidPackId: number | string | undefined) => {
  return useQuery<BidPack, Error>({
    queryKey: namedQueryKeyWithId("bidPacks", bidPackId),
    queryFn: () => fetchBidPackById(bidPackId),
    onError: () => objectWithIdNotFoundMessage(bidPackId, "Bid Pack"),
  });
};

const fetchBidPackById = async (id: number | string | undefined) => {
  const { data: bidPack } = await axios.get<BidPack>(bidPackUrls.apiUrlForBidPackWithId(id));

  return bidPack;
};
